<template lang="html">
  <div id="register-page">

    <section class="main-section">
      <b-form @submit="onSubmit">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-form">
              <div class="d-block">
                <h2 class="mb-2 text-center title-s1">Aplica para ser operador de camión</h2>

                <p class="text-center txt-c">Completa el siguiente formulario y nos pondremos en contacto contigo a la brevedad.</p>
              </div>

              <div class="box-white">
                <div class="row" v-if="step <= 2">
                  <div class="col-12 col-steps">
                    <h3 class="title">Formulario de Aplicación</h3>
                    <p>
                      <span v-if="step == 1">Paso 1 de 3 - Información Personal</span>
                      <span v-if="step == 2">Paso 2 de 3 - Documentos y Datos Personales (Opcional)</span>
                    </p>
                    <b-progress :value="step" :max="3" height="10px"></b-progress>

                    <div class="alert alert-warning mb-2" role="alert" v-if="step == 2">Todos los campos en esta sección son opcionales. Puedes completarlos ahora o más adelante.</div>
                  </div>
                </div>

                <!-- Paso 1 -->
                <div class="row" v-if="step == 1">
                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Nombre">
                      <b-form-input
                        v-model="form.name"
                        type="text"
                        placeholder=""
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Apellidos">
                      <b-form-input
                        v-model="form.apellidos"
                        type="text"
                        placeholder=""
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Teléfono">
                      <b-form-input
                        v-model="form.telefono"
                        type="text"
                        placeholder=""
                        minlength="10"
                        maxlength="10"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Email">
                      <b-form-input
                        v-model="form.email"
                        type="email"
                        placeholder=""
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-12 text-right col-input pt-1">
                    <b-button type="submit" class="btn-s1 bg-1">Siguiente</b-button>
                  </div>
                </div>
                <!--  -->

                <!-- Paso 2 -->
                <div class="row" v-if="step == 2">
                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Información Personal</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Fecha de nacimiento">
                      <b-form-input
                        v-model="form.nacimiento"
                        type="date"
                        placeholder=""
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Lugar de Residencia en México">
                      <b-form-input
                        v-model="form.estado"
                        type="text"
                        placeholder="Ciudad, Estado"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Licencia de Conducir</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Número de licencia B1">
                      <b-form-input
                        v-model="form.licencia"
                        type="text"
                        placeholder="Número de licencia"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Ajunto de Licencia B1"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.licenciaFile" plain></b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Pasaporte</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Número de pasaporte">
                      <b-form-input
                        v-model="form.pasaporte"
                        type="text"
                        placeholder="Número de pasaporte"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Fecha de expiración">
                      <b-form-input
                        v-model="form.pasaporte"
                        type="date"
                        placeholder=""
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Adjunto de Pasaporte"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.pasaporteFile" plain></b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">CURP</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Número de CURP">
                      <b-form-input
                        v-model="form.curp"
                        type="text"
                        placeholder="CURP (18 caracteres)"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Adjunto de CURP"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.curpFile" plain></b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Fotografía</h5>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Foto de identificación"
                      description="Formatos aceptados: JPG, PNG, PDF. Máximo 5MB">
                      <b-form-file accept=".jpg,.jpeg,.png,.pdf" v-model="form.foto" plain></b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-line">
                    <hr class="mt-" />
                  </div>

                  <div class="col-12 col-titles">
                    <h5 class="subtitle-1">Términos y Condiciones</h5>
                  </div>

                  <div class="col-12 col-input">
                    <div class="p-3 border rounded">
                      <b-form-checkbox class="custom-checkbox-1"
                        v-model="form.checkbox1"
                        required
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false">
                        <p>Acepto la política de privacidad</p>
                        <p class="mt-1 text-muted small">He leído y acepto la política de privacidad de Marquez Express.</p>
                      </b-form-checkbox>
                    </div>

                    <div class="p-3 mt-3 border rounded">
                      <b-form-checkbox class="custom-checkbox-1"
                        v-model="form.checkbox2"
                        required
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false">
                        <p>Acepto los términos y condiciones del proceso de contratación</p>
                        <p class="mt-1 text-muted small">He leído y acepto los términos y condiciones del proceso de contratación de Marquez Express.</p>
                      </b-form-checkbox>
                    </div>
                  </div>

                  <div class="col-12 col-input pt-4">
                    <div class="row">
                      <div class="col-6 text-left">
                        <a class="btn btn-s1 outline-1" @click="step = 1">Anterior</a>
                      </div>

                      <div class="col-6 text-right">
                        <b-button type="submit" class="btn-s1 bg-1">Siguiente</b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--  -->

                <!-- Paso 3 -->
                <div class="row" v-if="step == 3">
                  <div class="col-12 col-completed">
                    <div class="d-block mb-3">
                      <i class="fa-regular fa-circle-check icon"></i>
                    </div>

                    <h5 class="subtitle-2">¡Solicitud Enviada!</h5>

                    <h6 class="mt-3 text-muted" style="line-height: 1.5;">Gracias por tu interés en unirte a Marquez Express. Hemos recibido tu solicitud y nos pondremos en contacto contigo pronto.</h6>

                    <p class="mt-3">
                      <a class="btn btn-s1 outline-1" @click="step = 1">Enviar otra solicitud</a>
                    </p>
                  </div>
                </div>
                <!--  -->
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 1,

      form: {
        name: null,
      }
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();

      if(this.step == 2) {
        this.step = 3;
      }
      if(this.step == 1) {
        this.step = 2;
      }
    },
  },
}
</script>
